import classnames from "classnames";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Button,
  Card,
  CardBody,
  Container,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
} from "reactstrap";
import { countAssessments } from "../../store/assessments/action";
import { countQuestions } from "../../store/questionBank/action";
import "./AssessmentDashboard.scss";
import AssessmentTab from "./AssessmentTab/AssessmentTab";
import { dashboardHeaderCards } from "./constants";
import QuestionBankTab from "./QuestionBankTab/QuestionBankTab";
import ResultTab from "./ResultTab/ResultTab";
import { getResultsCount } from "../../store/results/action";

function AssessmentDashboard() {
  document.title = "Assessment Dashboard | RTS";
  const dispatch = useDispatch();

  const [activeTab, setActiveTab] = useState("1"); // State to track active tab
  const [dashboardData, setDashboardData] = useState({
    assessments: 0,
    questions: 0,
    invites: 0,
    results: 0,
  });

  const resultsCount = useSelector((state) => state?.ResultsReducer?.resultsCount);

  const questionCount = useSelector(
    (state) => state?.QuestionBankReducer?.questionCount
  );

  const assessmentCount = useSelector(
    (state) => state?.AssessmentsReducer.assessmentCount
  );

  useEffect(() => {
    dispatch(countQuestions());
    dispatch(countAssessments());
    dispatch(getResultsCount());
  }, []);

  useEffect(() => {
    if (questionCount) {
      setDashboardData((prevData) => ({
        ...prevData,
        questions: questionCount || 0,
      }));
    }
  }, [questionCount]);

  useEffect(() => {
    if (assessmentCount) {
      setDashboardData((prevData) => ({
        ...prevData,
        assessments: assessmentCount || 0,
      }));
    }
  }, [assessmentCount]);

  useEffect(() => {
    if (resultsCount) {
      setDashboardData((prevData) => ({
        ...prevData,
        results: resultsCount || 0,
      }));
    }
  }, [resultsCount]);

  const toggle = (tab) => {
    if (activeTab !== tab) setActiveTab(tab);
  };

  return (
    <div
      className="page-content"
      style={{ backgroundColor: "#fff", minHeight: "100vh" }}
    >
      <Container fluid>
        {/* Dashboard Header */}
        <div className="d-flex justify-content-between align-items-center mb-3">
          <span className="mb-0 fs-5 fw-semibold">Dashboard</span>
          <Button
            style={{ backgroundColor: "white", border: "1px solid #C3D3E2" }}
          >
            <i className="bi bi-download me-1"></i> Export
          </Button>
        </div>

        {/* Dashboard Cards */}
        <div className="d-flex flex-row gap-2 justify-content-between">
          {dashboardHeaderCards.map((card, index) => {
            let value;
            switch (card.title) {
              case "No. of Assessments":
                value = dashboardData.assessments;
                break;
              case "No. of Questions":
                value = dashboardData.questions;
                break;
              case "Total No. of Candidate Invites":
                value = dashboardData.invites;
                break;
              case "Completed Candidate Reports":
                value = dashboardData.results;
                break;
              default:
                value = 0;
            }

            return (
              <Card
                key={index}
                className="flex-grow-1"
                style={{
                  backgroundColor: card.backgroundColor,
                  flex: "1 1 25%",
                }}
              >
                <CardBody>
                  <div className="d-flex flex-column align-items-start gap-2">
                    <div
                      className="assessment-header-card-icon"
                      style={{
                        backgroundColor: card.iconBackgroundColor,
                      }}
                    >
                      <i
                        className={card.icon}
                        style={{ color: card.iconColor, fontSize: "18px" }}
                      ></i>
                    </div>
                    <span className="fw-semibold" style={{ fontSize: "23px" }}>
                      {value}
                    </span>
                    <span
                      className="fw-light"
                      style={{ color: "#425166", fontSize: "18px" }}
                    >
                      {card.title}
                    </span>
                  </div>
                </CardBody>
              </Card>
            );
          })}
        </div>

        {/* Tabs */}
        <Nav tabs className="mt-4">
          <NavItem>
            <NavLink
              className={classnames({ active: activeTab === "1" })}
              onClick={() => toggle("1")}
              style={{ cursor: "pointer" }}
            >
              Question Bank
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              className={classnames({ active: activeTab === "2" })}
              onClick={() => toggle("2")}
              style={{ cursor: "pointer" }}
            >
              Assessments
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              className={classnames({ active: activeTab === "3" })}
              onClick={() => toggle("3")}
              style={{ cursor: "pointer" }}
            >
              Result
            </NavLink>
          </NavItem>
        </Nav>

        <TabContent activeTab={activeTab} className="mt-3">
          {/* Tab 1 - Question Paper */}
          <TabPane tabId="1">
            <QuestionBankTab />
          </TabPane>
          <TabPane tabId="2">
            <AssessmentTab />
          </TabPane>
          <TabPane tabId="3">
            <ResultTab />
          </TabPane>
        </TabContent>
      </Container>
    </div>
  );
}

export default AssessmentDashboard;
